const FLASH_TOAST_KEY = 'flashToast.v1';
export const FLASH_TOAST_EVENT = 'flash-toast';

export type FlashToast = {
  message: string;
  variant?: 'success' | 'error' | 'info' | 'warning';
};

export function clearFlashToast(): void {
  try {
    sessionStorage.removeItem(FLASH_TOAST_KEY);
  } catch {
    // ignore storage failures (private mode, quota, etc.)
  }
}

export function setFlashToast(toast: FlashToast, options?: { persist?: boolean }): void {
  const shouldPersist = options?.persist ?? toast.variant === 'success';
  try {
    if (shouldPersist) {
      sessionStorage.setItem(FLASH_TOAST_KEY, JSON.stringify(toast));
    } else {
      // Error/info toasts are page-scoped; clear storage so navigation does not replay them.
      sessionStorage.removeItem(FLASH_TOAST_KEY);
    }
  } catch {
    // ignore storage failures (private mode, quota, etc.)
  }
  window.dispatchEvent(new CustomEvent<FlashToast>(FLASH_TOAST_EVENT, { detail: toast }));
}

export function consumeFlashToast(): FlashToast | null {
  try {
    const raw = sessionStorage.getItem(FLASH_TOAST_KEY);
    if (!raw) return null;
    sessionStorage.removeItem(FLASH_TOAST_KEY);
    const parsed = JSON.parse(raw) as FlashToast;
    if (!parsed?.message) return null;
    return parsed;
  } catch {
    return null;
  }
}